export default "__VITE_ASSET__977f5418__"